import { KButton, KSpan, KTitleSpan } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { LCReleaseForm, LCReleaseFormData, TerritoryDsp } from "../../../../types"
import { lang } from "../../../../constants/languages"
import { formatDate2, formatDuration, mapListToCamelCase } from "../../../../utility"
import { capitalize } from "lodash"
import AudioPlayer from "../track-detail/AudioPlayer"
import { Dialog } from "@headlessui/react"
//@ts-ignore
import SpotifyLogo from "../../../../assets/release-platform-icons/SpotifyLogo.png"
import { state51MainGenreMapping } from "../../../../constants"
import { releases } from "../../../../apis"

interface Dsps {
  name: string
  image_url: string
}

interface ComputedRight {
  name: string
  dsps: Dsps[]
}

const Distributions = ({ releaseForm, options }: { releaseForm: LCReleaseForm; options: any }) => {
  const [dspList, setDspList] = useState<TerritoryDsp[]>([])
  const [distributedRights, setDistributedRights] = useState([])
  const [notDistributedRights, setNotDistributedRights] = useState([])

  useEffect(() => {
    try {
      releases(
        `/release/label_camp_product_computed_rights/?product_id=${releaseForm.product.data.id}&label_id=${releaseForm.product.data.relationships.label.data.id}`,
        "get"
      ).then((resp) => {
        if (resp && resp["data"] && resp["data"].length > 0) {
          const rights = resp["data"][0]["rights"]
          setNotDistributedRights(rights.filter((right) => right["name"] === "Not distributed"))
          setDistributedRights(rights.filter((right) => right["name"] !== "Not distributed"))
        }
      })

      releases(`/release/asset_registry_dsp_list/?limit=${100}`, "get").then((resp) => {
        setDspList(mapListToCamelCase(resp.data.results))
      })
    } catch (e) {
      console.error("Error Getting Territory & Platform Rights")
    }
  }, [])

  const renderPlatforms = (platformList: Dsps[], territoryName: string) => {
    const releaseGenre = options.distributorProductSubGenreOptions.find(
      (subgenre) => subgenre.value === releaseForm.offer.data?.relationships["subgenre"]?.data?.id
    )?.label
    let releaseGenreMapped = ""
    if (releaseGenre && Object.keys(state51MainGenreMapping()).includes(releaseGenre)) {
      releaseGenreMapped = state51MainGenreMapping()[releaseGenre]
    }

    let allPlatformList: Dsps[] = [...platformList]
    if (territoryName === "Worldwide") {
      const processedDspList: Dsps[] = dspList
        .filter(
          (dsp) => dsp.label !== "Beatport" || releaseGenreMapped === "Electronic" || releaseGenreMapped === "Dance"
        )
        .map((dsp) => {
          return {
            name: dsp.label,
            image_url: dsp.image
          }
        })
      allPlatformList = allPlatformList.concat(processedDspList).sort((a, b) => a.name.localeCompare(b.name))
    }
    return (
      <div
        className="grid"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(calc(20% - 16px), calc(20% - 16px)))", gridGap: 16 }}
      >
        {allPlatformList.map((platform) => {
          return platform.name === "Spotify" ? (
            <div>
              <img style={{ width: 105 }} src={SpotifyLogo} />
            </div>
          ) : (
            <div className="flex items-center">
              <img src={platform["image_url"]} style={{ width: 32 }} />
              <div className="ml-2">
                <KSpan text={platform["name"]} color="black" />
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const renderComputedRights = (territoriesIncluded: boolean, computedRights: ComputedRight[]) => {
    if (computedRights.length === 0) {
      return <div />
    }

    if (!territoriesIncluded) {
      return (
        <div style={{ border: "1px solid rgb(230, 230, 230)", padding: 24 }}>
          {renderPlatforms(computedRights[0]["dsps"], "")}
        </div>
      )
    }

    return (
      <div style={{ padding: 24 }}>
        {computedRights.map((computedRight, index) => {
          return (
            <div className={`flex ${index !== 0 && "mt-10"}`} style={{ width: "100%" }}>
              <div style={{ width: "19%", borderRight: "1px solid rgb(235, 235, 235)" }}>
                <KSpan text={computedRight.name} color="black" />
              </div>
              <div style={{ width: "1%" }} />
              <div style={{ width: "80%" }}>{renderPlatforms(computedRight.dsps, computedRight.name)}</div>
            </div>
          )
        })}
      </div>
    )
  }

  const renderDistribution = () => {
    return (
      <div className={"flex"}>
        <div style={{ width: "100%" }}>
          <div className={"bg-white mt-0"}>
            <div className={"pt-4"}>
              <div className="block mt-2" style={{ width: "100%", border: "1px solid rgb(230, 230, 230)" }}>
                <div className="flex pl-4 pr-6 pt-2 pb-2" style={{ width: "100%", background: "rgb(242, 242, 242)" }}>
                  <div style={{ width: "20%" }} className="flex items-center">
                    <img src="/catalog_icons/earth-line.svg" className="mr-2" style={{ width: 28, height: 28 }} />

                    <KSpan text={lang.catalog.asset_registry.territory_and_platform_rights.territories} color="black" />
                  </div>
                  <div style={{ width: "80%" }} className="flex items-center">
                    <img src="/catalog_icons/layout-grid-line.svg" className="mr-2" style={{ width: 28, height: 28 }} />
                    <KSpan text={lang.catalog.asset_registry.territory_and_platform_rights.platforms} color="black" />
                  </div>
                </div>
                {renderComputedRights(true, distributedRights)}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return <div style={{ width: "100%" }}>{renderDistribution()}</div>
}

export default Distributions
